import { Upload } from "components/icons/generated";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useTypedContext from "hooks/useTypedContext";
import useCanManagedStateImportStack from "shared/Stack/access/useCanManagedStateImportStack";
import { StackContext } from "views/Stack/Context";
import { StackConfigVendorTerraform, TerraformWorkflowTool } from "types/generated";

import { showStackImportStateModal } from "../ImportStateModal";

const StackStateUploadButton = () => {
  const { stack } = useTypedContext(StackContext);

  const canImportState = useCanManagedStateImportStack()(stack);

  // State history is only available for Terraform stacks
  const vendorConfig = stack.vendorConfig as StackConfigVendorTerraform;

  const onUploadClick = () => {
    showStackImportStateModal({
      stackId: stack.id,
      workflowTool: vendorConfig?.workflowTool as TerraformWorkflowTool,
    });
  };

  return (
    <Tooltip
      active={!!canImportState.message}
      on={(props) => (
        <Button
          {...props}
          disabled={!canImportState.result}
          onPress={onUploadClick}
          startIcon={Upload}
          variant="secondary"
        >
          Import state
        </Button>
      )}
    >
      {canImportState.message}
    </Tooltip>
  );
};

export default StackStateUploadButton;
